import { useUserProfileViewCreator } from '@viewCreators/UserProfileViewCreator';
import { useEffect, useState } from 'react';
import { useAppCookies } from '@app/providers/AppCookieProvider';

export type UserProfileView = {
  id: number;
  firstName: string;
  lastName: string;
  avatarUrl: string;
  email: string;
  phone: string;
  phoneVerifiedOn: Date;
};

export const useUserProfileController = () => {
  const cookies = useAppCookies();
  const [view, setView] = useState<UserProfileView | null>(null);
  const { data, isLoading } = useUserProfileViewCreator(Number(cookies.profile.id));

  useEffect(() => {
    if (isLoading || !data) return;
    setView(data);
  }, [data, isLoading]);
  return {
    view: view,
  };
};
